<template>
  <div class="mb-3">
    <v-radio
      :label="$bct(radioTitle)"
      :value="value"
      class="c-black mt-0 mb-1"
      color="primary"
      hide-details
    />
    <div
      v-if="item.subtitle"
      class="c-light-black fs-15 mb-1 ps-8"
    >
      <span>{{ $bct(item.subtitle) }}</span>
      <span
        v-show="item.text"
        @click="readMore = !readMore"
        class="ms-1 c-primary pointer"
      >
        {{ $bct('Read more.') }}
      </span>
    </div>
    <transition name="fade">
      <div
        v-show="item.text && readMore"
        class="c-light-black fs-15 ps-8 mt-2"
      >
        {{ $bct(item.text) }}
      </div>
    </transition>
  </div>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  index: {
    type: Number,
    default: null,
  },
  item: {
    type: Object,
    required: true,
  },
  suffix: {
    type: String,
    default: null,
  },
  value: {
    type: [Number, String],
    default: null,
  },
});

const readMore = ref(false);

const radioTitle = computed(() => {
  if (props.suffix) {
    return [props.item.title, props.suffix].join(' ');
  }
  return props.item.title;
});
</script>
